import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

// 텍스트 박스를 재사용하기 위한 컴포넌트
function DescriptionBox({ children }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const boxWidth = windowWidth < 768 ? '80%' : '350px';

  return (
    <div
      style={{
        width: boxWidth,
        margin: '20px auto',
        padding: '15px',
        border: '1px solid #ccc',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9',
      }}
    >
      {children}
    </div>
  );
}
// Banner 컴포넌트: 3초마다 배경 이미지가 페이드 전환되는 캐러셀
function Banner() {
  const images = [
    '/img/CR2.jpg',
    '/img/CR1.jpg',
    '/img/CR3.jpg',
    '/img/huge1.jpg'
  ];

  // 현재 표시할 이미지 인덱스
 const [currentIndex, setCurrentIndex] = useState(0);
const [previousIndex, setPreviousIndex] = useState(1);
  // 페이드 중인지 여부
  const [isFading, setIsFading] = useState(false);

  const currentIndexRef = useRef(currentIndex);
  useEffect(() => {
    currentIndexRef.current = currentIndex;
  }, [currentIndex]);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setPreviousIndex(currentIndexRef.current);
      setIsFading(true);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        setIsFading(false);
      }, 1000);
    }, 5100);
    return () => clearInterval(interval);
  }, []);


  return (
    <div style={{ position: 'relative', width: '100%', height: '400px', overflow: 'hidden' }}>
      {/* 이전 이미지 (페이드 아웃) */}
      <img
        src={images[previousIndex]}
        alt="Previous Slide"
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          transition: 'opacity 1s ease-in-out',
          // 페이드 중이면 이전 이미지는 1→0 (서서히 사라짐)
          opacity: isFading ? 1 : 0
        }}
      />
      {/* 현재 이미지 (페이드 인) */}
      <img
        src={images[currentIndex]}
        alt="Current Slide"
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          transition: 'opacity 1s ease-in-out',
          // 페이드 중이면 현재 이미지는 0→1 (서서히 나타남)
          opacity: isFading ? 0 : 1
        }}
      />

      {/* 오버레이 (글자) */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          //backgroundColor: 'rgba(26, 26, 26, 0.7)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          color: '#fff',
          padding: '20px',
        }}
      >
        <h1 style={{ fontStyle: 'italic' }}>Welcome to Asan Memorial Park</h1>
        <h1 style={{ fontStyle: 'italic' }}>고인의 기억과 명예를 함께 합니다</h1>
      </div>
    </div>
  );

}



function CarouselModal({ images, onClose }) {
    const [current, setCurrent] = useState(0);
    
    const nextSlide = () => {
      setCurrent((current + 1) % images.length);
    };
    
    const prevSlide = () => {
      setCurrent((current - 1 + images.length) % images.length);
    };
    
    return ReactDOM.createPortal(
      <div 
        className="modal-overlay"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: '#000', // 완전한 검은색 배경
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
        }}
      >
        <div 
          className="modal-content"
          style={{
            position: 'relative',
            backgroundColor: '#000',
            padding: '20px',
            zIndex: 10000,
          }}
        >
          <button 
            className="close-button" 
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              background: '#eee',
              border: 'none',
              padding: '5px 10px',
              cursor: 'pointer',
              zIndex: 10001
            }}
          >
            X
          </button>
          <div 
            className="carousel"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <button 
              className="arrow left" 
              onClick={prevSlide}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '2rem',
                cursor: 'pointer',
                padding: '10px'
              }}
            >
              &lt;
            </button>
            <img 
              src={images[current]} 
              alt={`Slide ${current}`} 
              style={{ 
                position: 'relative', 
                zIndex: 10000,
                maxWidth: '500px',
                maxHeight: '400px'
              }}
            />
            <button 
              className="arrow right" 
              onClick={nextSlide}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '2rem',
                cursor: 'pointer',
                padding: '10px'
              }}
            >
              &gt;
            </button>
          </div>
        </div>
      </div>,
      document.body
    );
  }

// ContentSection 컴포넌트: 스크롤 애니메이션 효과와 왼쪽/오른쪽 배치를 적용한 콘텐츠 섹션
function ContentSection({ title, description, image, layout, carouselImages }) {
  const [showModal, setShowModal] = useState(false);
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  
  // Intersection Observer를 사용하여 섹션이 화면에 나타날 때 애니메이션 효과 적용
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            if (ref.current) observer.unobserve(ref.current);
          }
        });
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, []);
  
  return (
    <section ref={ref} className={`content-section ${isVisible ? 'visible' : ''}`}>
      <div className={`content-wrapper ${layout === 'left' ? 'left-image' : 'right-image'}`}>
        <div className="image-container">
          <img src={image} alt={title} />
        </div>
        <div className="text-container">
          <h2>{title}</h2>
          {/* DescriptionBox로 감싸기 */}
          <DescriptionBox>
            <p style={{ margin: 0,whiteSpace: 'pre-line'  }} dangerouslySetInnerHTML={{ __html: description }}></p>
          </DescriptionBox>
        </div>
      </div>
      {showModal && (
        <CarouselModal 
          images={carouselImages} 
          onClose={() => setShowModal(false)} 
        />
      )}
    </section>
  );
}

// Main 컴포넌트: 기본적인 About, Services, Contact 섹션
function Main() {
  return (
    <main className="main-content" style={{ maxWidth: '800px', margin: '40px auto'} }>
      {/* 공원 소개 섹션 */}
      <section id="about">
        <h2 style={{ display: 'inline-flex', alignItems: 'center' }}>
          {/* 글자 부분 */}
          <Link 
            to="/about" 
            style={{
              textDecoration: 'none', 
              color: 'inherit'
            }}
          >
            공원 소개
          </Link>
          {/* 화살표 부분 */}
          <Link 
            to="/about" 
            style={{
              marginLeft: '8px',
              textDecoration: 'none',
              color: 'inherit'
            }}
          >
            →
          </Link>
        </h2>
        <p style={{ marginTop: '-8px', fontSize: '0.95rem', wordBreak: 'keep-all'  }}>
          아산 메모리얼 파크는 고인에 대한 존경과 기억을 담아 
          정성스럽게 서비스를 제공합니다.
        </p>
      </section>

      {/* 분양 안내 섹션 */}
      <section id="services">
        <h2 style={{ display: 'inline-flex', alignItems: 'center' }}>
          <Link 
            to="/services" 
            style={{
              textDecoration: 'none', 
              color: 'inherit'
            }}
          >
            분양 안내
          </Link>
          <Link 
            to="/services" 
            style={{
              marginLeft: '8px',
              textDecoration: 'none',
              color: 'inherit'
            }}
          >
            →
          </Link>
        </h2>
        <p style={{ marginTop: '-8px', fontSize: '0.95rem', wordBreak: 'keep-all' }}>
          봉안당, 제사 및 추모 서비스 등 다양한 프로그램을 운영하고 있습니다.
        </p>
      </section>

      {/* 상담 안내 섹션 */}
      <section id="contact">
        <h2 style={{ display: 'inline-flex', alignItems: 'center' }}>
          <Link 
            to="/contact" 
            style={{
              textDecoration: 'none', 
              color: 'inherit'
            }}
          >
            상담 안내
          </Link>
          <Link 
            to="/contact" 
            style={{
              marginLeft: '8px',
              textDecoration: 'none',
              color: 'inherit'
            }}
          >
            →
          </Link>
        </h2>
        <p style={{ marginTop: '-8px', fontSize: '0.95rem', wordBreak: 'keep-all' }}>
          궁금하신 사항은 언제든지 연락 주시기 바랍니다.
        </p>
      </section>
    </main>
  );
}
function HighlightSection() {
  return (
    <section className="highlight-section">
      <p className="highlight-intro-small" style={{
  color: '#665e5c',      // 갈색 계열
  margin: '0',
  textAlign: 'center'
}}>
  아산 메모리얼 파크는 아산 최고의 관리 수준을 자랑하는
</p>

<p className="highlight-intro-big" style={{
  color: '#4b392e',
  margin: '0px 0 16px',
  textAlign: 'center',
  fontWeight: 'bold'
}}>
  “공원형 <span style={{ color: '#D4AF37' }}>프리미엄</span> 추모공원입니다.”
</p>
      <div className="highlight-cards">
        
        {/* 1번 카드 */}
        <div className="card">
          <div className="image-container">
            <img 
              src="/img/location.jpg" 
              alt="Location" 
              className="card-image"
            />
            <div className="card-number">1</div>
          </div>
          <div className="card-content">
            <h3>Location (입지)</h3>
            <p>
              • 수도권 인접<br/>
              • 넓은 주차 시설 확보<br/>
              • 자연과 함께하는 힐링
            </p>
          </div>
        </div>
        
        {/* 2번 카드 */}
        <div className="card">
          <div className="image-container">
            <img 
              src="/img/quality.jpg" 
              alt="Quality" 
              className="card-image"
            />
            <div className="card-number">2</div>
          </div>
          <div className="card-content">
            <h3>Quality (상품)</h3>
            <p>
              • 다양한 선택(1~24위)<br/>
              • 봉안당, 봉안묘, 수목장
            </p>
          </div>
        </div>
        
        {/* 3번 카드 */}
        <div className="card">
          <div className="image-container">
            <img 
              src="/img/coming.jpg" 
              alt="Coming" 
              className="card-image"
            />
            <div className="card-number">3</div>
          </div>
          <div className="card-content">
            <h3>Coming (미래)</h3>
            <p>
              • 고급화 전략<br/>
              • 각종 부대시설<br/>
            
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

// Home 컴포넌트: Banner, 여러 ContentSection (봉안당, 수목장, 평장묘, 휴게공간) 및 Main 섹션 통합
function Home() {
  const sections = [
    {
      title: <p style={{ textAlign: 'left', fontSize: '24px', color: '#231918' }}>
      <span 
        style={{
          display: 'inline-block',
          width: '8px',
          height: '32px',
          backgroundColor: '#D4AF37',
          marginRight: '8px',
          marginTop: '-10px',
          verticalAlign: 'left'
        }}
      ></span>
      여유로운 산책로
    </p>,
      description: '고인을 만나러오는날 여유로운 산책로에서 평화롭게 산책을 나서보세요',
      image: '/img/Stroll.png',
      layout: 'left',
    },
    {
      title: <p style={{ textAlign: 'left', fontSize: '24px', color: '#231918' }}>
      <span 
        style={{
          display: 'inline-block',
          width: '8px',
          height: '32px',
          backgroundColor: '#D4AF37',
          marginRight: '8px',
          marginTop: '0px',
          marginBottom: '-6px',
          verticalAlign: 'left'
        }}
      ></span>
      자연과 하나로
    </p>,
      description: '자연과 예술이 하나된 숲속 안식처. 봄, 여름, 가을, 겨울 고운님을 보다 편안한 안식처로 모시겠습니다.',
      image: '/img/withNature.png',
      layout: 'right',
    },
    {
      title: <p style={{ textAlign: 'left', fontSize: '24px', color: '#231918' }}>
      <span 
        style={{
          display: 'inline-block',
          width: '8px',
          height: '32px',
          backgroundColor: '#D4AF37',
          marginRight: '8px',
          marginTop: '0px',
          marginBottom: '-6px',
          verticalAlign: 'left'
        }}
      ></span>
      다양한 선택권
    </p>,
      description:  '봉안당, 봉안묘, 부부봉안묘 뿐 아닌, 협의를 통해 다양한 커스터마이징 등 다양한 선택권을 누릴 수 있습니다.',
      image: '/img/variety.png',
      layout: 'left',
    },
    {
      title: <p style={{ textAlign: 'left', fontSize: '24px', color: '#231918' }}>
      <span 
        style={{
          display: 'inline-block',
          width: '8px',
          height: '32px',
          backgroundColor: '#D4AF37',
          marginRight: '8px',
          marginTop: '0px',
          marginBottom: '-6px',
          verticalAlign: 'left'
        }}
      ></span>
      유러피안 휴게공간
    </p>,
      description: '아름다운 자연속에서 고품격 휴게공간에서 고인과의 만남을 되새기고 그리운 마음을 이야기 나누는 시간을 가져보세요.',
      image: '/img/huge1.jpg',
      layout: 'right',
    },
    {
      title: <p style={{ textAlign: 'left', fontSize: '24px', color: '#231918' }}>
      <span 
        style={{
          display: 'inline-block',
          width: '8px',
          height: '32px',
          backgroundColor: '#D4AF37',
          marginRight: '8px',
          marginTop: '0px',
          marginBottom: '-6px',
          verticalAlign: 'left'
        }}
      ></span>
      높은 접근성
    </p>,
      description:  '<strong>1시간</strong> 수도권에 인접한 지리적 강점 \n' +
      '<strong>1호선</strong> 대중교통으로 수도권과 연결\n' +
      '<strong>KTX</strong> 가장 빠른 접근성\n' +
      '<strong>대도시</strong> 수원, 평택, 세종, 천안 인접',
      image: '/img/location.png',
      layout: 'left',
    },
    {
      title: <p style={{ textAlign: 'left', fontSize: '24px', color: '#231918' }}>
      <span 
        style={{
          display: 'inline-block',
          width: '8px',
          height: '32px',
          backgroundColor: '#D4AF37',
          marginRight: '8px',
          marginTop: '0px',
          marginBottom: '-6px',
          verticalAlign: 'left'
        }}
      ></span>
      완비된 주차공간 
    </p>,
      description: '찾아주시는 분들의 편의를 위해 새롭게 주차시설을 추가하였습니다.이제 더욱 편리하고 여유로운 방문이 가능합니다.',
      image: '/img/parkinglot.jpg',
      layout: 'right',
    },
  ];
  
  return (
    <div>
      <Banner />
      <HighlightSection />
      <div className="spacer-medium"></div>
      <div className="content-sections">
        {sections.map((section, index) => (
          <ContentSection 
            key={index}
            title={section.title}
            description={section.description}
            image={section.image}
            layout={section.layout}
            carouselImages={section.carouselImages}
          />
        ))}
      </div>
      <div className="spacer-medium"></div>
      <Main />
      <div className="spacer-medium"></div>
    </div>
  );
}

export default Home;